import _ from 'lodash';

import {
  GetPhoneNumbersByCustomerResponse,
  TransformedGetPhoneNumbersByCustomerResponse,
  TransformedTwilioFlowResponse,
  TwilioFlowResponse,
} from './responses';

export const getPhoneNumbersByCustomerResponse = ({
  data,
}: GetPhoneNumbersByCustomerResponse): TransformedGetPhoneNumbersByCustomerResponse => {
  const phoneParams = data.module_instances.map(instance => ({
    id: instance.id,
    enabled: instance.enabled,
    instance_owner: instance.instance_owner,
    practice_id: instance.instance_owner.owner_identity,
    ...instance.params,
  }));
  return _.groupBy(phoneParams, item => item.instance_owner.owner_identity);
};

export const transformTwilioWorkflowResponse = ({
  data,
}: TwilioFlowResponse): TransformedTwilioFlowResponse => {
  const inbound_type = data.params_schema.properties.inbound_type;
  const twilio_studio_flow = data.params_schema.properties.twilio_studio_flow;
  return {
    inbound_type: {
      type: inbound_type?.type || 'select',
      required: inbound_type?.required || true,
      options: inbound_type?.options || [],
    },
    twilio_studio_flow: {
      type: twilio_studio_flow?.type || 'select',
      required: twilio_studio_flow?.required || true,
      options: twilio_studio_flow?.options || [],
    },
  };
};
